import Vue from "vue";
import Vuetify from "vuetify/lib";
// import 'vue-material-design-icons/styles.css';
// import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);
export default new Vuetify();
